import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getImageUrl } from "@/lib/api";
import { useCurrency } from "@/lib/CurrencyContext";
import api from "@/lib/api";

export const TourRecommendations = ({ tourId }) => {
  const [recs, setRecs] = useState([]);
  const { formatPrice } = useCurrency();

  useEffect(() => {
    if (!tourId) return;
    api.get(`/tours/${tourId}/recommendations`).then(r => setRecs(Array.isArray(r.data) ? r.data : [])).catch(() => {});
  }, [tourId]);

  if (recs.length === 0) return null;

  return (
    <div className="mt-12" data-testid="tour-recommendations">
      <h3 className="font-cormorant text-2xl font-light text-midnight mb-6">You May Also Like</h3>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        {recs.map((tour) => (
          <Link
            key={tour.tour_id}
            to={`/tours/${tour.tour_id}`}
            className="group block"
            data-testid={`rec-${tour.tour_id}`}
          >
            <div className="overflow-hidden aspect-[4/3] mb-3">
              <img
                src={getImageUrl(tour.images?.[0])}
                alt={tour.title}
                className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                loading="lazy"
              />
            </div>
            <p className="uppercase text-[10px] tracking-[0.25em] text-sandy font-manrope mb-1">{tour.category}</p>
            <h4 className="font-cormorant text-lg text-midnight mb-1 leading-tight">{tour.title}</h4>
            <p className="font-manrope text-sm text-midnight/60">From {formatPrice(tour.price)}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};
